import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2acd5e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-calendar-time-labels" }
const _hoisted_2 = { class: "widget-calendar-time-labels__label__text" }

import { PropType } from 'vue'
import { minutesToHours } from 'date-fns'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetTimeLabels',
  props: {
  timeSlots: {
    type: Array as PropType<number[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.timeSlots, (timeSlot) => {
      return (_openBlock(), _createElementBlock("div", {
        key: timeSlot,
        class: "widget-calendar-time-labels__label"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(`${_unref(minutesToHours)(timeSlot).toString().padStart(2, '0')}:${(
            timeSlot % 60
          )
            .toString()
            .padStart(2, '0')}`), 1)
      ]))
    }), 128))
  ]))
}
}

})